import {
  PREFIX_WIND_MAG_KPH
} from '../shared/behaviour_models_utils';
import {calculateDIR} from '../shared/direction';
import {
  calculateFFM_C,
  calculateFFM_DT,
  calculateFFM_NT,
  calculateFFM_PM
} from '../shared/ffm';
import {minZero} from '../../point_utils';
import {
  BARK_FUEL_LOADS,
  ELEVATED_FUEL_LOADS,
  NEAR_SURFACE_FUEL_LOADS,
  SURFACE_FUEL_LOADS
} from './constants';

export {calculateDIR};
export {
  calculateFFM_PM,
  calculateFFM_DT,
  calculateFFM_NT,
  calculateFFM_C
};

export function calculateROS_MF(wd, vars) {
  const ffm = calculateFFM_C(wd, vars);
  if (typeof ffm !== 'undefined') {
    return 18.35 * Math.pow(ffm, -1.495);
  }
  return undefined;
}

export function calculateROS_SF(wd, vars) {
  return Math.exp(0.069 * vars.slope);
}

export function calculateFROS(wd, vars) {
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  const ros_mf = calculateROS_MF(wd, vars);
  const ros_sf = calculateROS_SF(wd, vars);

  if (typeof wind_speed !== 'undefined' &&
      typeof ros_mf !== 'undefined' &&
      typeof ros_sf !== 'undefined') {
    return (30.0 + 1.531 * Math.pow(minZero(wind_speed - 5.0), 0.858) * Math.pow(vars.surface_hazard, 0.93) *
            Math.pow(vars.near_surface_hazard * vars.near_surface_height, 0.637) * 1.03) * ros_mf * ros_sf;
  }
  return undefined;
}

export function calculateFROS_NS(wd, vars) {
  const ros_mf = calculateROS_MF(wd, vars);
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];

  if (typeof wind_speed !== 'undefined' &&
      typeof ros_mf !== 'undefined') {

    const adjusted_wind_speed = (0.2 * wind_speed + 4) < 5 ? 0 : (0.2 * wind_speed + 6) - 5;

    return (30.0 + 1.531 * Math.pow(adjusted_wind_speed, 0.858) * Math.pow(vars.surface_hazard, 0.93) *
            Math.pow(vars.near_surface_hazard * vars.near_surface_height, 0.637) * 1.03) * ros_mf;
  }
  return undefined;
}

export function calculateFH(wd, vars) {
  const fros = calculateFROS(wd, vars);

  if (typeof fros !== 'undefined') {
    return 0.0193 * Math.pow(fros, 0.723) * Math.exp(0.64 * vars.elevated_height) * 1.07;
  }
  return undefined;
}

export function calculateSD(wd, vars) {
  const wind_speed = wd[PREFIX_WIND_MAG_KPH];
  const fros = calculateFROS(wd, vars);

  if (typeof wind_speed !== 'undefined' &&
      typeof fros !== 'undefined') {
    if (fros < 150) {
      return 50.0;
    }
    const spotting_distance =
      176.969 *
      (Math.atan(vars.surface_hazard) * Math.pow((fros / Math.pow(wind_speed, 0.25)), 0.5)) +
      1568800 *
      (Math.pow(vars.surface_hazard, -1) * Math.pow((fros / Math.pow(wind_speed, 0.25)), -1.5)) -
      3015.09;
    return Math.max(50.0, spotting_distance);
  }
  return undefined;
}

export function calculateTFL(wd, vars) {
  const surface_fuel_load = SURFACE_FUEL_LOADS[vars.surface_hazard];
  const near_surface_fuel_load = NEAR_SURFACE_FUEL_LOADS[vars.near_surface_hazard];
  const elevated_fuel_load = ELEVATED_FUEL_LOADS[vars.elevated_hazard];
  const bark_fuel_load = BARK_FUEL_LOADS[vars.bark_hazard];
  return surface_fuel_load + near_surface_fuel_load + elevated_fuel_load + bark_fuel_load;
}

export function calculateFI(wd, vars) {
  const fros = calculateFROS(wd, vars);
  const total_fuel_load = calculateTFL(wd, vars);

  if (typeof fros !== 'undefined' &&
      typeof total_fuel_load !== 'undefined') {
    return 18600 * fros / 3600 * total_fuel_load / 10;
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/vesta/calculations.js